package com.wintermar.inspection.core.ui.widget

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.material3.HorizontalDivider
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.theme.color.model.ThemeColor

@Composable
fun DefaultHorizontalDivider(
    color: ThemeColor = LocalAppTheme.current.color,
    modifier: Modifier = Modifier
) {
    HorizontalDivider(
        modifier = modifier.fillMaxWidth()
            .background(color.surface.neutral.subtlest.default),
        color = color.border.subtle
    )
}
